import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onUnmounted, Ref, ref } from 'vue';

import EasyMDE from 'easymde';
import 'easymde/dist/easymde.min.css';

// :value and @input to mimick v-model. (does this work?)

export default /*#__PURE__*/_defineComponent({
  __name: 'EasymdeView',
  props: {
    options: {},
    value: {}
  },
  emits: ['change', 'input'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit

const editor: Ref<EasyMDE | null> = ref(null);
const editorRef: Ref<HTMLElement | null> = ref(null);

onMounted(() => {
    
    if (editorRef.value != null) {
        const options = {
            element: editorRef.value,
            
            initialValue: props.value,
            spellChecker: false,

            ...props.options
        };
        
        editor.value = new EasyMDE(options);

        editor.value.codemirror.on('change', (...args) => {
            emit('change', editor.value, ...args);
            emit('input', editor.value?.value());
        })

    }

});

onUnmounted(() => {
    if (editor.value !== null) {
        editor.value.cleanup();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("textarea", {
    ref_key: "editorRef",
    ref: editorRef
  }, null, 512))
}
}

})